import Grid from 'components/Grid';
import EditMapButton from 'components/buttons/EditMapButton';
import RecenterMapButton from 'components/buttons/RecenterMapButton';
import ToggleBoundaryButton from 'components/buttons/ToggleBoundaryButton';
import ToggleFlightPathsButton from 'components/buttons/ToggleFlightPathsButton';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const MapVerticalControlBar = ({
    className = '',
    isDrawingEnabled = true,
    layerToggles,
    onClickEditMap,
    onClickRecenterMap,
    testId = TEST_ID
}: Props) => {
    const editButtonHiddenStyle = isDrawingEnabled ? styles.hidden : '';

    return (
        <Grid className={`${styles.mapVerticalControlBar} ${className}`} testId={testId}>
            <RecenterMapButton className={styles.button} onClick={onClickRecenterMap} />

            <EditMapButton
                className={`${styles.button} ${editButtonHiddenStyle}`}
                onClick={onClickEditMap}
            />

            {layerToggles?.hasFlightPaths && (
                <ToggleFlightPathsButton
                    className={styles.button}
                    isActive={layerToggles.isFlightPathsVisible}
                    onClick={layerToggles.onToggleFlightPaths}
                />
            )}

            {layerToggles?.hasBoundary && (
                <ToggleBoundaryButton
                    className={styles.button}
                    isActive={layerToggles.isBoundaryVisible}
                    onClick={layerToggles.onToggleBoundary}
                />
            )}
        </Grid>
    );
};

export default MapVerticalControlBar;
